<template>
  <div class="layer-order-actions d-flex flex-column align-items-center justify-content-center">
    <button
      v-if="canMoveUp"
      type="button"
      class="layer-order-button"
      :title="$t('master.orthophoto.actions.moveLayerUp')"
      @click.prevent.stop="$emit('move', 'up')"
    >
      <i class="mc-icon icon-outline_chevron-up"></i>
    </button>
    <button
      v-if="canMoveDown"
      type="button"
      class="layer-order-button"
      :title="$t('master.orthophoto.actions.moveLayerDown')"
      @click.prevent.stop="$emit('move', 'down')"
    >
      <i class="mc-icon icon-outline_chevron-down"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'OrthophotoLayerControls',
  props: {
    canMoveUp: Boolean,
    canMoveDown: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.layer-order-actions {
  width: 100%;
  gap: 2px;
}

.layer-order-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 20px;
  padding: 0;
  color: $primary;
  background: transparent;
  border: 0;
  border-radius: 4px;

  &:hover {
    background: rgba($primary, 0.08);
  }
}
</style>
